import { CircularProgress, Divider, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useUpdateWithInfiniteListInvalidation } from "hooks/useUpdateWithInfiniteListInvalidation";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const DEFAULT_REJECTION_EMAIL_CONTENT = `Thank you for your interest in joining the Neta Foundation platform. We are going to need more information to open your account.

Let’s find a time to have a conversation to go over the details. Please reach out to us at platform@netafoundation.org or +1 (646) 600-9433.`;

interface ModalProps {
  visible: boolean;
  decision: { sub: string; value: "PENDING" | "ACCEPTED" | "REJECTED" };
  close: React.Dispatch<React.SetStateAction<boolean>>;
}
export const DecideRequestModal: React.FC<ModalProps> = ({
  visible,
  close,
  decision,
}) => {
  const [reason, setReason] = useState("");
  const [emailContent, setEmailContent] = useState(
    DEFAULT_REJECTION_EMAIL_CONTENT
  );
  const isRejecting = decision.value === "REJECTED";
  const { mutate, isLoading } = useUpdateWithInfiniteListInvalidation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={visible}
      onClose={() => close(false)}
      fullWidth={isRejecting}
      maxWidth="sm"
    >
      <DialogTitle color="primary">
        {decision.value === "ACCEPTED" ? "Accept" : "Reject"} user request
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>
          Are you sure you want to{" "}
          {decision.value === "ACCEPTED" ? "accept" : "reject"} this user
          request?
        </Typography>

        {decision.value === "REJECTED" && (
          <TextField
            value={reason}
            margin="normal"
            fullWidth
            InputLabelProps={{ shrink: true }}
            type="text"
            multiline={true}
            rows={3}
            label="Rejection reason"
            name="reason"
            onChange={(e) => setReason(e.target.value)}
          />
        )}

        {isRejecting && (
          <TextField
            value={emailContent}
            margin="normal"
            fullWidth
            InputLabelProps={{ shrink: true }}
            type="text"
            multiline={true}
            minRows={6}
            label="Rejection Email Content"
            name="emailContent"
            helperText='Sent to the user after "Dear <name>,". Leave a blank line between paragraphs.'
            error={!emailContent.trim()}
            onChange={(e) => setEmailContent(e.target.value)}
          />
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <>
          <Button
            variant="contained"
            disabled={isLoading || (isRejecting && !emailContent.trim())}
            startIcon={
              isLoading && <CircularProgress size={20} color="inherit" />
            }
            onClick={() => {
              mutate(
                {
                  resource: "users/handelUserRequest",
                  values: {
                    status: decision.value,
                    reason: reason,
                    ...(isRejecting && { emailContent }),
                  },
                  id: decision.sub,
                },
                {
                  onSuccess: () => {
                    if (decision.value === "ACCEPTED") {
                      navigate("/users/status/accepted");
                    } else {
                      navigate("/users/status/rejected");
                    }
                  },
                }
              );
              close(false);
            }}
          >
            Confirm
          </Button>
          <Button variant="outlined" onClick={() => close(false)}>
            Cancel
          </Button>
        </>
      </DialogActions>
    </Dialog>
  );
};
